
// This file is part of main.min.js which is loaded from CornellCookson.cshtml

// Scripts for dealer locator contact form
// AccountId hidden field needs to be populated with the CRM account ID of the dealer we're contacting

// Add this code in an javascript widget on the contact page
/*
$(document).ready(function () {
    setFormAction();
    populateAccountIdField();
    markRequiredFields();
});
*/

// Sitefinity sets the form action to something like this, which breaks our detail page: /dealers/advanced?sf_cntrl_id=ctl00%24Contentplaceholder1%24C031
// Update the form action to put the dealer URL back in: /dealers/advanced/a6uj9a002bq6-reitz-door-co-(coming-soon)
function setFormAction() {
    if (document.forms.length > 0) {
        document.forms[0].action = window.location.pathname;
        console.log('Form action set to ' + window.location.pathname);
    } else {
        console.warn('No forms found on the page');
    }
}

function populateAccountIdField() {
    var accountId = getParameterByName('accountId');
    if (accountId) {
        $('input[name=AccountId]').val(accountId);
    } else {
        console.warn('accountId not found');
    }
}

function markRequiredFields() {
    $('input[required]').each(function () {
        $(this).prev('label').append('<span style="font-size:large;color:#ab162b;">*</span>');
    });
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}



// Generic contact a dealer functionality

$(document).ready(function () {
    $('.dealer-dropdown').select2({
        allowClear: true,
        minimumResultsForSearch: 20,
        placeholder: 'Select a dealer',
        templateResult: formatDealerItem,
        templateSelection: formatDealerItem,
        theme: "bootstrap",
        width: '100%'
    });

    $('.dealer-dropdown').change(function (e) {
        // console.log('change');
        var accountId = $('.dealer-dropdown').val();
        $('input[name="AccountId"]').val(accountId);
    });
});

function formatDealerItem(item) {
    var element = $(item.element);
    if (!element) {
        return item.text;
    }
    var url = element.data('tier-url');
    if (!url) {
        return item.text;
    }
    var alt = element.data('tier-title');
    return $('<span><img src="' + url + '" class="d-inline mr-10" alt="' + alt + '" /><span>' + item.text + '</span></span>');
}
